// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JIdueq1EKXQxQgyk96OcB {\n    font-family: 'Nanum Gothic', sans-serif;\n}", "",{"version":3,"sources":["webpack://./src/components/reusable/navmenu/styles/NavMenu.css"],"names":[],"mappings":"AAEA;IACI,uCAAuC;AAC3C","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');\n\n.NavMenu {\n    font-family: 'Nanum Gothic', sans-serif;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NavMenu": "JIdueq1EKXQxQgyk96OcB"
};
export default ___CSS_LOADER_EXPORT___;
